module.exports = __webpack_public_path__ + "img/Citibanamex.2144422e.png";